<template>
  <!-- Header & Footer template -->
  <div id="app" role="main">
    <!-- Location Alert -->
    <LocationAlert ref="locationAlert" />

    <!-- Top menu row. If the screen is smaller than 940px, collapse the links and display Hamburger menu -->
    <div class="topmenurow">
      <div id="nav1">
        <a href="/">HOME</a>
        <!-- <router-link @click.native="$scrollToTopdesc" to="/why-eat-seasonally">WHY EAT SEASONALLY?</router-link> -->
        <router-link
          @click.native="$scrollToTop(330)"
          :to="{ name: 'whyeatseasonally' }"
          >WHY EAT SEASONALLY?</router-link
        >
        <router-link @click.native="$scrollToTop(330)" :to="{ name: 'about' }"
          >ABOUT</router-link
        >
        <router-link
          @click.native="$scrollToTop(330)"
          :to="{ name: 'gettheapp' }"
          >GET THE APP</router-link
        >
        <router-link
          @click.native="$scrollToTop(330)"
          :to="{ name: 'newsletter' }"
          >NEWSLETTER</router-link
        >
        <router-link @click.native="$scrollToTop(330)" :to="{ name: 'press' }"
          >PRESS</router-link
        >
        <a href="mailto:jerusha@gracelinks.org?subject=Seasonal%20Food%20Guide"
          >CONTACT</a
        >
      </div>
    </div>

    <!-- Hamburger menu. If the screen is bigger than 940px, hide the Hamburger menu and display the links in the top row -->
    <div v-if="mobilescreen" class="popup" @click="popupmenu()">
      <div class="circle">
        <div class="circle-bar-content">☰</div>
        <span class="popuptext" id="myPopup">
          <div class="menunav">
            <div class="separator" />
            <div class="nav"><a href="/">HOME</a></div>

            <div class="nav">
              <router-link
                @click.native="$scrollToTop(200)"
                :to="{ name: 'whyeatseasonally' }"
                >WHY EAT SEASONALLY?</router-link
              >
            </div>
            <div class="nav">
              <router-link
                @click.native="$scrollToTop(200)"
                :to="{ name: 'about' }"
                >ABOUT</router-link
              >
            </div>
            <div class="nav">
              <router-link
                @click.native="$scrollToTop(200)"
                :to="{ name: 'gettheapp' }"
                >GET THE APP</router-link
              >
            </div>
            <div class="nav">
              <router-link
                @click.native="$scrollToTop(200)"
                :to="{ name: 'newsletter' }"
                >NEWSLETTER</router-link
              >
            </div>
            <div class="nav">
              <router-link
                @click.native="$scrollToTop(200)"
                :to="{ name: 'press' }"
                >PRESS</router-link
              >
            </div>
            <div class="nav">
              <a
                href="mailto:jerusha@gracelinks.org?subject=Seasonal%20Food%20Guide"
                >CONTACT</a
              >
            </div>
            <div class="separator" />
            <!-- socia media icons -->
            <div class="nav">
              <a target="_blank" href="https://www.facebook.com/FoodPrintOrg"
                ><img
                  src="@/assets/img/icons/facebook-b.svg"
                  class="sm_icons"
                  alt="Facebook - FoodPrint"
                  height="35px"
                  width="35px"
              /></a>
              <a target="_blank" href="https://twitter.com/foodprintorg"
                ><img
                  src="@/assets/img/icons/twitter-b.svg"
                  class="sm_icons"
                  alt="Twitter - FoodPrint"
                  height="35px"
                  width="35px"
              /></a>
              <a target="_blank" href="https://www.pinterest.com/foodprintorg/"
                ><img
                  src="@/assets/img/icons/pinterest-b.svg"
                  class="sm_icons"
                  alt="Pinterest - FoodPrint"
                  height="35px"
                  width="35px"
              /></a>
              <a target="_blank" href="https://www.instagram.com/foodprintorg/"
                ><img
                  src="@/assets/img/icons/instagram-b.svg"
                  class="sm_icons"
                  alt="Instagram - FoodPrint"
                  height="35px"
                  width="35px"
              /></a>
            </div>
          </div>
        </span>
      </div>
    </div>

    <!-- Dynamic background image -->
    <div
      class="section-top"
      :style="'background: url(' + getbkUrl(month, state) + ')'"
    >
      <!-- SFG logo -->
      <!-- <div class="logo_top"></div> -->
      <img
        v-if="logomobile"
        src="@/assets/img/other/SFG_Header_Graphics_2_Desktop.png"
        class="logosfg"
        alt="SFG - Logo"
        width="560"
        height="432"
      />
      <img
        v-else
        src="@/assets/img/other/SFG_Header_Graphics_2_Desktop.png"
        class="logosfg"
        alt="SFG Logo"
        width="560"
        height="432"
      />

      <!-- States, Months & Vegs Dropdowns -->
      <div class="row topMenuRow" style="margin-bottom: 0">
        <div class="colwidth">
          <!-- 1. Select a state -->
          <div class="col m4 s12 xs12">
            <div id="input_container">
              <select
                v-model="statestate"
                class="browser-default"
                aria-label="Select a State"
                @change="onselectstate(statestate)"
              >
                <option>Select a State</option>
                <option
                  style="padding-left: 20px; margin-left: 20px; left: 20px"
                >
                  Use My Location
                </option>
                <!-- <optgroup label="States"> -->
                <option
                  v-for="s in filteredItems1"
                  :key="s.value"
                  :value="s.desc"
                  :selected="state"
                >
                  {{ s.desc }}
                </option>
                <optgroup label="California">
                  <option>Northern California</option>
                  <option>Southern California</option>
                </optgroup>
                <option
                  v-for="s in filteredItems2"
                  :key="s.value"
                  :value="s.desc"
                  :selected="state"
                >
                  {{ s.desc }}
                </option>
                <optgroup label="Florida">
                  <option>North Florida</option>
                  <option>South Florida</option>
                </optgroup>
                <option
                  v-for="s in filteredItems3"
                  :key="s.value"
                  :value="s.desc"
                  :selected="state"
                >
                  {{ s.desc }}
                </option>
              </select>
              <img
                src="@/assets/img/icons/pin32.svg"
                id="input_img"
                alt="Select Location"
              />
              <img
                v-if="state == 'Select a State'"
                style="pointer-events: none"
                :src="dropdownarrowstate()"
                id="input_img1"
                alt="Select Location"
              />
              <img
                v-else
                :src="dropdownarrowstate()"
                id="input_img1"
                @click="resetstate()"
                alt="Select Location"
              />
            </div>
          </div>

          <!-- 2. Select a month -->
          <div class="col m4 s12 xs12">
            <div id="input_container">
              <select
                v-model="monthmonth"
                class="browser-default"
                aria-label="Select a Month"
                @change="onselectmonth(monthmonth)"
              >
                <option>Any Month</option>
                <option>Current Month Selection</option>
                <option
                  v-for="(m, value) in months"
                  :key="value"
                  :value="m.desc"
                  :selected="month"
                >
                  {{ m.desc }}
                </option>
              </select>
              <img
                src="@/assets/img/icons/cal32.svg"
                id="input_img"
                alt="Select Month"
              />
              <img
                v-if="month == 'Any Month'"
                style="pointer-events: none"
                :src="dropdownarrowmonth()"
                id="input_img1"
                alt="Select Month"
              />
              <img
                v-else
                :src="dropdownarrowmonth()"
                id="input_img1"
                @click="resetmonth()"
                alt="Select Month"
              />
            </div>
          </div>

          <!-- 3. Select a veg -->
          <div class="col m4 s12 xs12">
            <div id="input_container">
              <select
                v-model="cardcard"
                class="browser-default"
                aria-label="Select Any Produce"
                @change="onselectcard(cardcard)"
              >
                <option>Any Produce</option>
                <option
                  v-for="(c, index) in $cards"
                  :key="index"
                  :selected="card"
                >
                  {{ c.name }}
                </option>
              </select>
              <img
                src="@/assets/img/icons/pro32.svg"
                id="input_img"
                alt="Select Produce"
              />
              <img
                v-if="card == 'Any Produce'"
                style="pointer-events: none"
                :src="dropdownarrowcard()"
                id="input_img1"
                alt="Select Produce"
              />
              <img
                v-else
                :src="dropdownarrowcard()"
                id="input_img1"
                @click="resetcard()"
                alt="Select Produce"
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- vue-router: fade only when closing a card (vegdetail → listing), not when opening one -->
    <transition :name="pageTransition" @after-enter="restoreListingScroll">
      <router-view :key="routerViewKey" />
    </transition>

    <!-- footer menu -->
    <!-- socia media icons -->
    <div class="smlinks">
      <a target="_blank" href="https://www.facebook.com/FoodPrintOrg"
        ><img
          src="@/assets/img/icons/facebook-b.svg"
          style="height: 35px"
          alt="Facebook - FoodPrint"
          height="35px"
          width="35px"
      /></a>
      <a target="_blank" href="https://twitter.com/foodprintorg"
        ><img
          src="@/assets/img/icons/twitter-b.svg"
          style="height: 35px"
          alt="Twitter - FoodPrint"
          height="35px"
          width="35px"
      /></a>
      <a target="_blank" href="https://www.pinterest.com/foodprintorg/"
        ><img
          src="@/assets/img/icons/pinterest-b.svg"
          style="height: 35px"
          alt="Pinterest - FoodPrint"
          height="35px"
          width="35px"
      /></a>
      <a target="_blank" href="https://www.instagram.com/foodprintorg/"
        ><img
          src="@/assets/img/icons/instagram-b.svg"
          style="height: 35px"
          alt="Instagram - FoodPrint"
          height="35px"
          width="35px"
      /></a>
    </div>
    <div class="footer">
      © {{ new Date().getFullYear() }}
      <a href="https://gracecommunicationsfoundation.org/" target="_blank"
        >GRACE Communications Foundation</a
      >. All rights reserved.<br /><a
        href="https://foodprint.org/privacy-and-terms-of-use/"
        target="_blank"
        >Privacy and Terms of Use</a
      >
    </div>
    {{ updatecomputedvar() }}
  </div>
</template>

<script>
import Vue from "vue";
import cards from "@/components/staticFiles/sfg-38.json";
import {
  listStates,
  cities,
  states,
} from "@/components/staticFiles/stateLookup.js";
import { listmonths } from "@/components/staticFiles/months.js";
import { getbkUrl, toURLreverse } from "@/components/api/imagepath.js";
import {
  dropdownarrowstate,
  dropdownarrowmonth,
  dropdownarrowcard,
} from "@/components/api/dropdownicons.js";
import LocationAlert from "@/components/LocationAlert.vue";
// URL slug validators — keep dropdowns in sync only for valid route params
import {
  isValidState,
  isValidMonth,
  isValidCard,
} from "@/components/api/routeValidation.js";
import {
  LISTING_ROUTES,
  consumeListingScrollY,
} from "@/router.js";

// vue global variables - sfg.json & scroll to the top
Vue.prototype.$cards = cards;
Vue.prototype.$scrollToTop = (x) => window.scrollTo(0, x);

export default {
  components: {
    LocationAlert,
  },
  data() {
    return {
      states: listStates,
      months: listmonths,
      monthmonth: "Any Month",
      statestate: "Select a State",
      cardcard: "Any Produce",
      // location is requested only when the user picks "Use My Location"
      // from the state dropdown (see onselectstate). Do NOT request on page load.
      coordinate: {},
      mobilescreen: window.innerWidth <= 940 ? true : false,
      logomobile: window.innerWidth <= 600 ? true : false,

      // imported methods
      getbkUrl: getbkUrl,
      toURLreverse: toURLreverse,
      dropdownarrowstate: dropdownarrowstate,
      dropdownarrowmonth: dropdownarrowmonth,
      dropdownarrowcard: dropdownarrowcard,
      // '' = no animation; 'page-fade' only when closing produce detail
      pageTransition: "",
    };
  },

  computed: {
    // 'cardcard','monthmonth','statestate' variables are set for dropdown selections.
    // computed properties 'card','month','state' are checking router props and changing dropdown selection ('cardcard','monthmonth','statestate') if needed (e.g when you refresh the page).
    // Only sync from the route when the slug is valid — invalid URLs show NotFound
    // and must not push bad values into the selects (that can fire resetstate → "/").
    card: {
      get() {
        return this.$route.params.card && isValidCard(this.$route.params.card)
          ? toURLreverse(this.$route.params.card)
          : this.cardcard;
      },
      set(newName) {
        return newName;
      },
    },
    state: {
      get() {
        return this.$route.params.state && isValidState(this.$route.params.state)
          ? toURLreverse(this.$route.params.state)
          : this.statestate;
      },
      set(newName) {
        return newName;
      },
    },
    month: {
      get() {
        return this.$route.params.month && isValidMonth(this.$route.params.month)
          ? toURLreverse(this.$route.params.month)
          : this.monthmonth;
      },
      set(newName) {
        return newName;
      },
    },
    filteredItems1: function () {
      return this.states.slice(0, 4);
    },
    filteredItems2: function () {
      return this.states.slice(7, 10);
    },
    filteredItems3: function () {
      return this.states.slice(13, 55);
    },
    // Group listing routes under one key so state/month changes don't
    // re-trigger the page fade; vegdetail ↔ listing still animates.
    routerViewKey() {
      const name = this.$route.name;
      if (["home", "selectstate", "homestate"].includes(name)) {
        return "listing";
      }
      if (name === "vegdetail") {
        return "vegdetail";
      }
      return this.$route.fullPath;
    },
  },

  methods: {
    // force to update computed vars
    // Only copy valid route params into dropdown v-models. Invalid slugs are
    // ignored so NotFound pages don't corrupt selectors or redirect home.
    updatecomputedvar() {
      this.statestate =
        this.$route.params.state && isValidState(this.$route.params.state)
          ? this.state
          : this.statestate;
      this.monthmonth =
        this.$route.params.month && isValidMonth(this.$route.params.month)
          ? this.month
          : this.monthmonth;
      this.cardcard =
        this.$route.params.card && isValidCard(this.$route.params.card)
          ? this.card
          : this.cardcard;
    },

    // After page-fade enter: restore listing scroll saved when opening a card.
    // Must run here (not in router scrollBehavior) so the Home grid has full
    // height — otherwise the browser clamps Y and you land at the top.
    restoreListingScroll() {
      if (!LISTING_ROUTES.includes(this.$route.name)) {
        return;
      }
      const y = consumeListingScrollY();
      if (y == null) {
        return;
      }
      this.$nextTick(() => {
        requestAnimationFrame(() => {
          window.scrollTo(0, y);
        });
      });
    },

    // open hamburger menu
    popupmenu() {
      var popup = document.getElementById("myPopup");
      popup.classList.toggle("show");
    },

    // show hamburger icon when resizing the screen
    onResize() {
      this.mobilescreen = window.innerWidth <= 940 ? true : false;
      this.logomobile = window.innerWidth <= 600 ? true : false;
    },

    // convert selected strings to urls
    toURLm(veg) {
      // current month
      var crdt = [new Date().getDate(), new Date().getMonth() + 1];
      var cdate =
        (crdt[0] >= 1 && crdt[0] <= 15 ? "Early" : "Late") +
        " " +
        listmonths.find(({ value }) => value == crdt[1] * 2).desc.split(" ")[1];

      // if the month is not selected, select the current month
      if (!veg || veg.length == 0 || veg == "Any Month") {
        this.monthmonth = cdate;
        return cdate.replace(/ /g, "-").toLowerCase();
      } else {
        this.state =
          this.state == "Select a State" ? this.geoloc(this.state) : this.state;
        return veg.replace(/ /g, "-").toLowerCase();
      }
    },

    // convert selected strings to urls
    toURL(veg) {
      if (!veg || veg.length == 0 || veg == "Select a State") {
        this.statestate = this.geoloc(veg);
        return this.geoloc(veg).replace(/ /g, "-").toLowerCase();
      } else {
        return veg.replace(/ /g, "-").toLowerCase();
      }
    },

    // reset selected value when clicking 'x' icon (or selecting default val)
    resetstate() {
      this.statestate = "Select a State";
      this.monthmonth = "Any Month";
      this.cardcard = "Any Produce";
      // .catch swallows vue-router's NavigationDuplicated when we're already
      // on "/" (e.g. user denies the geolocation prompt from the home page).
      return this.$router.push("/").catch((err) => {
        if (err && err.name !== "NavigationDuplicated") throw err;
      });
    },

    // reset selected value when clicking 'x' icon (or selecting default val)
    resetmonth() {
      if (this.cardcard == "Any Produce") {
        this.monthmonth = "Any Month";
        // return this.$router.push('/')
        return this.$router.push({
          name: "selectstate",
          params: { state: this.toURL(this.statestate) },
        });
      } else {
        this.monthmonth = "Any Month";
      }
    },

    // reset selected value when clicking 'x' icon (or selecting default val)
    resetcard() {
      if (this.month == "Any Month") {
        this.cardcard = "Any Produce";
        return this.$router.push({
          name: "selectstate",
          params: { state: this.toURL(this.statestate) },
        });
      } else {
        this.cardcard = "Any Produce";
        return this.$router.push({
          name: "homestate",
          params: {
            state: this.toURL(this.statestate),
            month: this.toURLm(this.monthmonth),
          },
        });
      }
    },

    // change url path when selecting card dropdown
    onselectcard(val) {
      // if selected value = any produce -> run reset function
      if (val == "Any Produce") {
        return this.resetcard();

        // else push router URL
      } else {
        return this.$router.push({
          name: "vegdetail",
          params: { card: this.toURL(val), state: this.toURL(this.state) },
        });
      }
    },

    // change url path when selecting state dropdown
    async onselectstate(val) {
      if (val == "Select a State") {
        return this.resetstate();
      } else if (val == "Use My Location") {
        // Request the browser geolocation only now, on user action.
        // This both enables location (triggers the browser permission
        // prompt) AND auto-selects the matching state once we have coords.
        let coords;
        try {
          coords = await this.$getLocation(
            { enableHighAccuracy: 0, timeout: Infinity, maximumAge: 0 },
            false,
          );
        } catch (e) {
          // User denied or the request failed -- don't silently fall back
          // to Southern California; reset the dropdown so it's clear the
          // detection didn't run.
          // eslint-disable-next-line no-console
          console.warn("Geolocation request failed or was denied:", e);

          // Show location disabled alert if permission was denied
          if (e && e.code === e.PERMISSION_DENIED) {
            this.$refs.locationAlert.show();
          }

          // Reset only the state dropdown without affecting month and produce selections
          this.statestate = "Select a State";
          this.coordinate = {};
          return;
        }

        // Save the resolved coordinates and compute the closest state.
        this.coordinate = coords;
        const detectedState = this.geogeoLoc(); // e.g. "New York"
        this.statestate = detectedState; // updates the dropdown via v-model

        // Navigate based on which fields are already selected (same logic as manual state selection)
        // .catch handles the case where the user re-selects "Use My Location"
        // and we end up on the same route.
        if (this.card == "Any Produce" && this.month == "Any Month") {
          return this.$router
            .push({
              name: "selectstate",
              params: { state: this.toURL(detectedState) },
            })
            .catch((err) => {
              if (err && err.name !== "NavigationDuplicated") throw err;
            });
        } else if (this.card == "Any Produce" && this.month != "Any Month") {
          return this.$router
            .push({
              name: "homestate",
              params: {
                state: this.toURL(detectedState),
                month: this.toURLm(this.month),
              },
            })
            .catch((err) => {
              if (err && err.name !== "NavigationDuplicated") throw err;
            });
        } else {
          return this.$router
            .push({
              name: "vegdetail",
              params: {
                card: this.toURL(this.card),
                state: this.toURL(detectedState),
              },
            })
            .catch((err) => {
              if (err && err.name !== "NavigationDuplicated") throw err;
            });
        }
      } else {
        if (this.card == "Any Produce" && this.month == "Any Month") {
          return this.$router.push({
            name: "selectstate",
            params: { state: this.toURL(val) },
          });
        } else if (this.card == "Any Produce" && this.month != "Any Month") {
          return this.$router.push({
            name: "homestate",
            params: { state: this.toURL(val), month: this.toURLm(this.month) },
          });
        } else {
          return this.$router.push({
            name: "vegdetail",
            params: { card: this.toURL(this.card), state: this.toURL(val) },
          });
        }
      }
    },

    // change url path when selecting month dropdown
    onselectmonth(val) {
      // current date
      var crdt = [new Date().getDate(), new Date().getMonth() + 1];
      var cdate =
        (crdt[0] >= 1 && crdt[0] <= 15 ? "Early" : "Late") +
        " " +
        listmonths.find(({ value }) => value == crdt[1] * 2).desc.split(" ")[1];

      if (val == "Any Month") {
        return this.resetmonth();
      } else if (val == "Current Month Selection") {
        // When a produce card is selected we stay on the `vegdetail`
        // route -- only update the month dropdown locally. Navigating
        // to `homestate` would drop the :card param and kick the user
        // off the produce detail page.
        if (this.card !== "Any Produce") {
          this.monthmonth = cdate;
          return;
        }
        this.monthmonth = cdate;
        if (this.month !== cdate || !this.$route.params.month) {
          return this.$router
            .push({
              name: "homestate",
              params: {
                state: this.toURL(this.state),
                month: this.toURLm(this.monthmonth),
              },
            })
            .catch((err) => {
              if (err && err.name !== "NavigationDuplicated") throw err;
            });
        }
      } else {
        if (this.card == "Any Produce") {
          return this.$router.push({
            name: "homestate",
            params: { state: this.toURL(this.state), month: this.toURLm(val) },
          });
        } else {
          this.monthmonth = val;
        }
      }
    },

    // run geoloc function
    geoloc(state) {
      if (state == "Use My Location") {
        return (this.statestate = this.geogeoLoc());
      } else if (state == "Select a State") {
        return (this.statestate = this.geogeoLoc());
      }
    },

    // convert coordinates into location
    geogeoLoc() {
      var geoloc1 = this.coordinate;

      if (typeof Number.prototype.toRad === "undefined") {
        Number.prototype.toRad = function () {
          return (this * Math.PI) / 180;
        };
      }

      const lat = geoloc1.lat ? geoloc1.lat : 34;
      const lon = geoloc1.lng ? geoloc1.lng : -118;
      const myLoc = [lat, lon];
      const keys = Object.keys(states);
      const length = keys.length;
      const R = 3959; // radius of the earth, in miles
      const min = [9000, "XE"]; // Set sortest distance from coords to 9000 miles and state as XE

      // The Havesine formula for calculating distances on the surface of a sphere
      function calcDist(p1Lat, p1Lon, distLat, distLon, p2Lat, p2Lon) {
        const a =
          Math.sin(distLat / 2) * Math.sin(distLat / 2) +
          Math.sin(distLon / 2) *
            Math.sin(distLon / 2) *
            Math.cos(p2Lat) *
            Math.cos(p2Lon);
        const c = 2 * Math.atan2(Math.sqrt(Math.abs(a)), Math.sqrt(1 - a));
        return R * c;
      }

      for (let i = 0; i < length; i++) {
        // Get the state center latitude
        const stateLat = states[keys[i]][0];

        // Get the state center longitude
        const stateLon = states[keys[i]][1];

        // Take the difference of the users' lat/long and the lat/long of state centers (compare first to see which val is bigger for subtraction to be valid)
        const latDiff = Math.abs(myLoc[0].toRad() - stateLat.toRad());
        const lonDiff = Math.abs(myLoc[1].toRad() - stateLon.toRad());

        // Convert all coordinates to radians
        // Calculate: the distance to state center coords using 1) state center coords 2) the difference between loc/center 3) the user's coordinates
        const dist = calcDist(
          myLoc[0].toRad(),
          myLoc[1].toRad(),
          latDiff,
          lonDiff,
          states[keys[i]][0].toRad(),
          states[keys[i]][1].toRad(),
        );

        // If the distance is shorter than the current "winner", update winner
        if (dist < min[0]) {
          min[0] = dist;
          min[1] = keys[i];
        }
      }

      // Check to see if the coordinates are withn ~20 miles of the top 307 U.S. cities. If so, use those states instead
      for (let p = 0; p < cities.length; p++) {
        const stateLat = cities[p][1];
        const stateLon = cities[p][2];
        const latDiff = Math.abs(myLoc[0].toRad() - stateLat.toRad());
        const lonDiff = Math.abs(myLoc[1].toRad() - stateLon.toRad());
        const dist = calcDist(
          myLoc[0].toRad(),
          myLoc[1].toRad(),
          latDiff,
          lonDiff,
          cities[p][1].toRad(),
          cities[p][2].toRad(),
        );

        if (dist < min[0]) {
          min[0] = dist;
          min[1] = cities[p][0];
        }
      }

      // If outside the US, set to California
      if (
        min[1] === "XE" ||
        min[1] === "XW" ||
        min[1] === "XN" ||
        min[1] === "XS"
      ) {
        min[1] = "SCA";
      }
      // return {"desc": (listStates.find( ({ value }) => value == min[1] )).desc, "value": min[1]}
      return listStates.find(({ value }) => value == min[1]).desc;
    },
  },

  created() {
    window.addEventListener("resize", this.onResize);
    // Animate only vegdetail → listing (card "x"). Opening a card stays instant.
    this._removePageTransitionGuard = this.$router.beforeEach((to, from, next) => {
      this.pageTransition =
        from.name === "vegdetail" && LISTING_ROUTES.includes(to.name)
          ? "page-fade"
          : "";
      next();
    });
  },

  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
    if (this._removePageTransitionGuard) {
      this._removePageTransitionGuard();
    }
  },
};
</script>

<style lang="scss">
// Font variables
$header-font: "Museo Slab";
$main-font: "Droid Sans";
$main-font-bold: "Droid Sans Bold";

// Font sizes
$font-sz-base: 14px;
$font-sz-12: 0.8571rem; // ~12px;
$font-sz-16: 1.143rem; // ~16px;
$font-sz-18: 1.286rem; // ~18px;
$font-sz-20: 1.429rem; // ~20px;
$font-sz-22: 1.571rem; // ~22px;
$font-sz-26: 1.875rem; // ~26px;
$font-sz-30: 2.143rem; // ~30px;
$font-sz-32: 2.286rem; // ~32px;
$font-sz-38: 2.714rem; // ~38px;

// Color variables
$color-teal: #339999; // Learn & Cook button color
$color-white: #ffffff; // generic white
$color-black: #2a2b2c; // form black
$color-black-2: #191a1a; // veg card black
$color-black-3: #414042; // veg paragraph black
$color-black-4: #95989a; // dropdown border black
$color-green: #4a654d; // green footer links
$color-green-2: #8cc63f; // green wheel color
$color-gray: #808080; // gray wheel color
$color-gray-2: #cccccc; // gray wheel color
$color-gray-3: #727374; // gray wheel title color
$color-red: #ff0000; // red form error
$color-offwhite: #eee; // For About Page SVGs
$box-shadow-veg: rgba(0, 0, 0, 0.16);

// Size of card and wheel box in detail mode
$detail-height: 390px;

// Size of detail and box in mobile
$mobile-box-width: 307px;

// hamburger menu
$circleleft: 190px;
$navbottom: 170px;

// import old sfg styles
@import "./components/stylesheets/sfgold/fonts";
@import "./components/stylesheets/sfgold/veg-card";
@import "./components/stylesheets/sfgold/buttons";
@import "./components/stylesheets/sfgold/sections";
@import "./components/stylesheets/sfgold/rows";
@import "./components/stylesheets/sfgold/images";
@import "./components/stylesheets/sfgold/typography";
@import "./components/stylesheets/sfgold/ul";
@import "./components/stylesheets/sfgold/forms";
@import "./components/stylesheets/sfgold/veg-detail";
@import "./components/stylesheets/sfgold/staticPages";
// @import "./components/stylesheets/sfgold/backgrounds";
@import "./components/stylesheets/sfgold/svg";
@import "./components/stylesheets/sfgold/mobile-landscape";
@import "./components/stylesheets/sfgold/downloadApp";

// import sfg-vue styles
@import "./components/stylesheets/hamburger";
@import "./components/stylesheets/header";
@import "./components/stylesheets/vegcards";
@import "./components/stylesheets/footer";
@import "./components/stylesheets/wheel";

html {
  margin-top: -60px;
  font-size: $font-sz-base; // 14px;
  // scroll-behavior: initial;
}
#app {
  font-family: "Museo Slab";
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}

// Subtle crossfade between produce detail ↔ listing (keep it short / soft).
.page-fade-enter-active,
.page-fade-leave-active {
  transition: opacity 0.12s ease;
}
.page-fade-enter,
.page-fade-leave-to {
  opacity: 0;
}
body {
  overflow-x: hidden !important;
  margin: 0;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #212529;
  text-align: left;
  background-image: url("./assets/img/other/bg-light-3000x1500.jpg");
  background-repeat: no-repeat;
  background-attachment: fixed;
  background-size: cover;
}
h1 {
  margin-bottom: 10px;
  margin-bottom: 50px;
}
h2 {
  font-size: 26px;
}

//scss old SFG styles

// Main font
.hidden {
  display: none;
}
a:hover {
  text-decoration: none;
}

top-layer {
  z-index: 50000;
}
@media (min-width: 1900px) {
  .row-veg {
    margin-left: 15% !important;
    margin-right: 15% !important;
  }
}

// static pages

.notFoundPage {
  max-width: 960px !important;
}
.staticPage {
  display: block;
  margin-left: auto;
  margin-right: auto;
  max-width: 650px;
  overflow-x: hidden;
}
.form-control {
  line-height: 32px;
  margin: 0 auto;
  max-width: 550px;
}
#form-check-wrapper {
  margin: 10px auto;
  max-width: 550px;
}
.clear {
  margin-top: 20px;
}
.displaced {
  left: -5000px;
  position: absolute;
}
.promo-table {
  background-color: #fff;
  text-align: center;
}
.other-orgs-box {
  background-color: #fff;
  height: 225px;
  padding: 25px;
}
.press-links {
  margin-left: auto;
  margin-right: auto;
  max-width: 980px;
}
h2 .press-page {
  margin-bottom: 50px;
}
.white-block .press-page {
  // padding: 50px 0;
}
#row-other-orgs {
  // margin: 50px 0;
}
#youtube-offline {
  background-color: #fff;
  padding: 5px;
}
a.twitter-link .press-page,
a.youtube-link .press-page {
  word-break: break-all;
}
#press-row-video {
  display: table;
  margin: 0 auto;
}
#press-row-tweets {
  display: table;
  margin: 0 auto !important;
  text-align: center;
}
.no-text-break {
  word-break: normal !important;
}
#droz-embed {
  margin-top: 12px;
  max-width: 495px;
  max-height: 275px;
}

.twitter-tweet {
  max-width: 500px;
}

.tweets-embedded {
  width: 500px;
}

.form-check {
  padding-left: 0%;
  min-width: 431px;
}

.form-check-label {
  padding-left: 4%;
  min-width: 90%;
}
@media (max-width: 767px) {
  #droz-embed {
    width: 320px;
    height: 190px;
  }
  .twitter-tweet {
    max-width: 339px !important;
  }
  .twitter-tweet .safari {
    margin: -170px;
  }
  .white-box {
    background-color: #fff;
    word-wrap: break-word;
    padding: 10px;
    margin-bottom: 25px;
  }
  a#twitter-name {
    font-weight: 700;
  }
}
@media only screen and (max-device-width: 500px) {
  .other-orgs-box {
    width: 250px;
  }
  .other-orgs-really-small {
    max-width: 200px;
  }
}
@media only screen and (min-device-width: 501px) {
  .other-orgs-box {
    width: 300px;
  }
}

/***************************************Fix for Safari for Press Page ******************************************/

#about-intro {
  font-size: 1.571rem;
}
.h3-static {
  font-family: "Droid Sans";
  font-size: 1.571rem;
  font-weight: 700;
  line-height: 1.571rem;
  margin-bottom: 30px;
  margin-top: 30px;
}
.h2-produce {
  font-family: "Museo Slab";
  font-size: 2.143rem;
  margin-bottom: 15px;
  margin-top: 30px;
  text-align: center;
}
.svg-pinterest-2,
.svg-social-1 {
  fill: none;
}
.svg-pinterest-1,
.svg-social-2 {
  fill: #414042;
}
.icon-box {
  height: 200px;
  width: 200px;
  padding: 10px;
}
.icon-box {
  margin-right: 15px;
}
.st-svg-b,
.gl-svg-c,
.mt-svg-c,
.st-svg-c,
.wfc-svg-b {
  fill: white;
}
.gl-svg-d,
.mt-svg-b,
.st-svg-c,
.wfc-svg-c,
.wfc-svg-d {
  fill: #eee;
  font-size: 14px;
  font-family: "Droid Sans";
  font-weight: 400;
  letter-spacing: 0.001em;
}
.wfc-svg-a {
  fill: #28bcb5;
}
.st-svg-a {
  fill: #be301f;
}
.st-svg-b,
.st-svg-d {
  letter-spacing: 0.001em;
}
.st-svg-e {
  font-size: 10px;
}
.st-svg-e,
.st-svg-f {
  font-family: "Droid Sans";
  font-weight: 400;
}
.st-svg-f {
  fill: #eee;
  font-size: 13px;
}
.gl-svg-a {
  fill: #acba00;
}
.gl-svg-b {
  fill: none;
  stroke: #fff;
  stroke-width: 1.5px;
}
.mt-svg-a {
  fill: #191a1a;
}
.fpo-svg-a {
  fill: #30793b;
}
.fpo-svg-b {
  fill: #ffffff;
}
.fpo-svg-c {
  fill: #eeeeee;
  font-size: 14px;
  font-family: Droid Sans;
  font-weight: 400;
  letter-spacing: 0.001em;
}

/*********************************************************Desktop*************************************************************************/

.icon-box {
  margin-bottom: 75px;
}

#icon-mt {
  margin-right: 0;
}

/*********************************************************Mobile*********************************************************************************/

@media (max-width: 767px) {
  .icon-box {
    margin-right: 0;
    margin-bottom: 20px;
  }
}

/******************************************************************************************************iPad Portrait and Landscape**********************************/

@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) {
  .icon-box {
    margin-bottom: 15px;
  }
}
</style>
